<template>
  <div v-if="
    inputObj.templates.structure
    && inputs
  ">


  <div
   v-if="list.length > 0"
  >

    {{ $t('invoice_company.inputs.organization.title') }}
    <multiselect
        v-if="list.length > 0"
        v-model="inputs[id]"
        @update:modelValue="setCompany($event);"
        :options="list"
        track-by="id"
        label="title"
        :searchable="true"
        :hideSelected="false"
        :placeholder="inputObj.placeholder? inputObj.placeholder: 'Vyberte možnost'"
    >

      <template v-slot:singleLabel="{ option }">
        <span>{{ option.title }} | IC: {{ option.organization_id }}</span>
      </template>


      <template v-slot:option="{ option, search }">
        <span>{{ option.title }} | IC: {{ option.organization_id }}</span>
      </template>

      <template v-slot:noResult>
        <div class="multiselect--no-results">Zadne vysledky pro tento dotaz</div>
      </template>

      <template v-slot:noOptions>
        <div class="multiselect--no-results">Zadne vysledky pro tento dotaz [noOption]</div>
      </template>
    </multiselect>
  </div>

    <template v-if="inputObj.params.type == 'vendor' && list.length == 0">
      <span class="text-warning">
        <i class="bi bi-exclamation-triangle-fill me-1"></i>
        {{ $t('invoice_company.inputs.organization.vendor_hint') }}
      </span>
    </template>
    <template
      v-if="inputObj.params.type == 'vendor' || (inputObj.params.type == 'client' && inputObj.params.vendor_id)"
    >
      <div v-for="(item, index) in inputObj.templates.structure">
        <template
            v-if="item.type == 'hidden'"
        >
          <input
              v-model="inputs[index]"
              type="hidden"

          />
        </template>

        <template
            v-else-if="item.type == 'text'"
        >
          <label
              :for="'company_' + inputObj.name + '_' + index"
          >
            {{item.title}}
          </label>


          <div class="input-group mb-3">
            <input
                v-model="inputs[index]"
                :id="'company_' + inputObj.name + '_' + index"
                type="text"
                :placeholder="item.title"
                :class="'form-control' + (item.class? (' ' + item.class): '')"
            />
            <template
                v-if="item.lookup"
            >
              <div

                  @click.prevent="callLookupAction(item.lookup.method, inputs[index], item.lookup)"
                  :class="'btn btn-outline-secondary' +  '' + (!inputs[index]? ' disabled': '')"
              >
                <i
                    v-if="item.lookup.ico"
                    :class="item.lookup.ico"
                ></i>
                {{item.lookup.title}}
              </div>


              <div
                  v-if="item.lookup.loading === true"
              >
                [loading]
              </div>

              <div
                  v-if="item.lookup.error"
                  class="text-danger"
              >
                {{item.lookup.error}}
              </div>
            </template>


          </div>






        </template>

        <template
            v-else-if="item.type == 'textarea'"
        >
          <label
              :for="'company_' + inputObj.name + '_' + index"
          >
            {{item.title}}
          </label>
          <textarea
              v-model="inputs[index]"
              :id="'company_' + inputObj.name + '_' + index"
              :placeholder="item.title"
              :class="'form-control' + (item.class? (' ' + item.class): '')"
          ></textarea>
        </template>

        <template
            v-else-if="item.type == 'bool_switch'"
        >
          <div class="form-check form-switch mt-2 mb-2">
            <input
                @change="setBool(index, $event.target.checked)"
                v-model="inputs[index]"
                class="form-check-input"
                type="checkbox"
                role="switch"
                :id="'company_' + inputObj.name + '_' + index"
            >
            <label
                class="form-check-label"
                :for="'company_' + inputObj.name + '_' + index"
            >
              {{item.title}}
            </label>
          </div>
        </template>

        <template
            v-else-if="item.type == 'select'"
        >
          <label
              :for="'company_' + inputObj.name + '_' + index"
          >
            {{item.title}}
          </label>
          <select
              v-model="inputs[index]"
              :id="'company_' + inputObj.name + '_' + index"
              :placeholder="item.title"
              :class="'form-select' + (item.class? (' ' + item.class): '')"
          >
            <option
                v-for="(option) in item.options"
                :value="option.id"
            >
              {{option.title}}
            </option>

          </select>
        </template>

        <template
            v-else-if="item.type == 'sub'"
        >
          <label
              class="form-check-label"
          >
            {{item.title}}
          </label>

          <div
              class="ms-4"
          >
            <div
                v-for="(subitem, subindex) in item.items"
            >
              <label
                  :for="'company_' + inputObj.name + '_' + index+ '_' + subindex"
                  class="form-check-label"
              >
                {{subitem.title}}
              </label>
              <input
                  v-model="inputs[index][subindex]"
                  :id="'company_' + inputObj.name + '_' + index+ '_' + subindex"
                  :type="subitem.type"
                  :placeholder="subitem.title"
                  :class="'form-control' + (subitem.class? (' ' + subitem.class): '')"
                  @input="inputValidate($event, subitem)"
                  :maxlength="(subitem.params && subitem.params.maxlength)? subitem.params.maxlength: null"
              />

              <div
                  v-if="subitem.validation && subitem.validation.result === false"
                  class="text-danger"
              >
                {{subitem.validation.message}}
              </div>

            </div>
          </div>
        </template>

        <template
            v-else-if="item.type == 'image_file'"
        >
          <label
              :for="'company_' + inputObj.name + '_' + index"
          >
            {{item.title}}
          </label>


          <div v-if="inputs[index]">

            <img :src="inputs[index]" alt="Preview" style="max-width: 300px;">


            <span
                @click.prevent="removeImage(index)"
                class="btn btn-outline-primary"
            >
            <i class="bi bi-trash me-1"></i>
              {{ $t('invoice_company.inputs.logo.remove_hint') }}
            Odstranit logo
          </span>

            <div v-if="item.loading">
              [loading]
            </div>
          </div>

          <input
              @change="uploadImage($event, index, item)"
              type="file"
              :id="'company_' + inputObj.name + '_' + index"
              :placeholder="item.title"
              :class="'form-control' + (item.class? (' ' + item.class): '')"
              accept="image/*"
          />

        </template>


        <template v-else>
          <display-debug>
            <template #debugView>
              ITEM: {{index}} {{item}}
            </template>
          </display-debug>

        </template>



      </div>

      <div
          v-if="inputObj.params.is_saving"
          class="mt-2 text-end"
      >
        <span
            v-if="company_save.status === true"
            class="text-success"
        >
        <i class="bi bi-check-circle-fill me-1"></i> {{company_save.message}}
      </span>
        <span
            v-else-if="company_save.status === false"
            class="text-danger"
        >
        <i class="bi bi-exclamation-circle-fill me-1"></i> {{company_save.message}}
      </span>

        <div
            @click.prevent="saveCompany()"
            class="btn btn-secondary ms-3"
        >
          {{inputObj.params.text.save_btn_title}}
          <i class="bi bi-box-arrow-down ms-1"></i>
        </div>
      </div>
    </template>

    <template
        v-else-if="inputObj.params.type == 'client'"
    >

      <span class="text-danger">
        <i class="bi bi-shield-fill-exclamation me-1"></i>
        {{ $t('invoice_company.inputs.organization.client_search_hint') }} |
      </span>
    </template>
    <template
        v-else-if="inputObj.params.type == 'vendor'"
    >
      <span class="text-danger">
        <i class="bi bi-shield-fill-exclamation me-1"></i>
        {{ $t('invoice_company.inputs.organization.client_create_hint') }} |

      </span>

    </template>

  </div>

  <!--

  <display-debug>
    <template #debugView>
      inputObj.params: {{inputObj.params}}
    </template>
  </display-debug>

  <display-debug>
    <template #debugView>
      inputs: {{list.length}}
    </template>
  </display-debug>





    <display-debug>
      <template #debugView>
        inputs: {{inputs}}
      </template>
    </display-debug>



    <display-debug>
      <template #debugView>
        list: {{list}}
      </template>
    </display-debug>

    <display-debug>
      <template #debugView>
        modelValue: {{modelValue}}
      </template>
    </display-debug>


    <display-debug>
      <template #debugView>
        inputModel: {{inputModel}}
      </template>
    </display-debug>



      <display-debug>
        <template #debugView>
          formObj.general: {{formObj.general.inputs}}
        </template>

      </display-debug>


      <display-debug>
        <template #debugView>
          inputModel: {{inputModel}}
        </template>
      </display-debug>

      <display-debug>
        <template #debugView>
          inputObj: {{inputObj}}
        </template>
      </display-debug>
    -->

<!--
  <display-debug>
    <template #debugView>
      devDraw: {{devDraw}}
    </template>

  </display-debug>

  <display-debug>
    <template #debugView>
      formObj.general: {{formObj.general.inputs.display_type_id.val}}
    </template>

  </display-debug>

  <display-debug>
    <template #debugView>
      inputObj: {{inputObj}}
    </template>
  </display-debug>


-->



</template>

<script>

import ImageComponent from "@/components/general/Image.vue";



import axios from "axios";
import multiselect  from 'vue-multiselect'
import DisplayDebug from "@/components/general/DisplayDebug.vue";
import VueMultiselect from "vue-multiselect";

export default {
  name: "InvoiceCompanyInput",
  components: {
    VueMultiselect,
    DisplayDebug,
    axios,
    multiselect,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    //"modelValue": [Object, String, Number],
    "modelValue": {
      type: [Object, String, Number],
      required: false,
      //default: null,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
    "id": {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      company_save: {
        status: null,
        message: null
      },
      list: [],
      inputs: {},
      is_open: true,
      inputModel: {
        id: null,
        title: null,
        organization_id: '09536612',
        tax_id: '',
        is_vat: false,
        address: null,
        street_number: null,
        city: null,
        zip: null,
        country_code: null,
        bank_account: null,
        phone: null,
        email: null,
        note: null,
        is_locked: false
      },
    }
  },
  created() {
    this.createInputStructure();
    if(this.modelValue) {
      this.fillStructure( this.modelValue);
    }
  },
  mounted() {
    if(this.inputObj.params.type == 'vendor') {
      this.list = this.inputObj.templates.data;
    }
  },

  methods: {

    fillStructure(data) {
      for( const i in data ) {
        this.inputs[i] = data[i];
      }
    },

    uploadImage(event, input_name, item){
      item.loading = true;
      this.echoTime();
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.inputs[input_name] = e.target.result;
          item.loading = false;
          this.echoTime();
        };
        reader.readAsDataURL(file);
      }
    },



    setBool(name, input) {
      if(
          this.inputObj.params.type == 'vendor'
          && name == 'is_vat'
      ) {
        this.formObj.general.inputs.raw_data.val.vendor.is_vat = input;
        //console.log('dev company set vat',name, input);
      }
    },

    removeImage(input){
      if(confirm("Opravdu chce odstranit obrazek?")) {
          delete this.inputs[input];
      }
    },

    echoTime() {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');
      const milliseconds = Math.floor(now.getMilliseconds() / 100); // Získá desetiny sekundy
      console.log('time', `${hours}:${minutes}:${seconds}.${milliseconds}`)
    },


    inputValidate(event, item){
      //console.log('dev inputValidate ', event.target.value)
      if(
          item.validation
          && event.target.value
      ) {
        if(item.validation.regexp) {
          //*const pattern = '^\\d{4}$'

          const regex = new RegExp(item.validation.regexp);
          if(!regex.test(event.target.value)) {
            item.validation.result = false;
            item.validation.message = item.validation.text.fail;
          }else{
            item.validation.result = true;
            delete item.validation.message;
          }
        }
      }
    },


    setCompany(event){
      //console.log('dev setCompany X', event)
      if(event) {
        for(const i in event) {
          if(typeof this.inputs[i] != "undefined") {
            if(
                this.inputs[i] != null
                && typeof this.inputs[i] == "object"
            ) {
              for(const s in this.inputs[i]) {
                if(
                    event[i]
                    && typeof event[i][s] != "undefined"
                ){
                  this.inputs[i][s] = event[i][s]
                }else{
                  this.inputs[i][s] = null
                }
              }
            } else{
              this.inputs[i] = event[i];
            }
          }
        }
      }
    },

    saveCompany(){
      //console.log('dev saveCompany', this.inputs)

      let formData = new FormData();
      formData.append(this.getApiConfig('invoice.save_organization.input.data'), JSON.stringify(this.inputs));
      if(this.inputObj.params.is_vendor) {
        formData.append(this.getApiConfig('invoice.save_organization.input.is_vendor'), true);
      } else {
        formData.append(this.getApiConfig('invoice.save_organization.input.is_vendor'), false);
        if(this.inputObj.params.vendor_id) {
          formData.append(this.getApiConfig('invoice.save_organization.input.parent_id'), this.inputObj.params.vendor_id);
        }
      }


      axios.defaults.baseURL = this.getBaseRoot();
      let apiPath = this.getApiConfig('invoice.save_organization.path')
      axios({
        url: apiPath,
        data: formData,
        method: this.getApiConfig('invoice.save_organization.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        if(res.data.status){
          this.company_save = {
            status: true,
            message: this.inputObj.params.text.save.success
          }

          this.list.push(
              res.data.response.item
          );
          this.inputs.id = res.data.response.item.id

          console.error("saveCompany OK", this.inputs);
        }else{
          //todo vysledky validace
          this.company_save = {
            status: false,
            message: this.inputObj.params.text.save.fail
          }

          if(res.data.response.fail) {
            this.company_save.message = res.data.response.fail;
          }
        }
      })
      .catch((err) => {
        this.company_save = {
          status: false,
          message: this.inputObj.params.text.save.fail
        }
        console.error("saveCompany ERR", err);
      })
    },


    createInputStructure(){
      if(this.inputObj.templates.structure) {
        this.inputs = {};
        for(const i in this.inputObj.templates.structure) {
          this.inputs[i] = (typeof this.inputObj.templates.structure[i].default_value != "undefined")? this.inputObj.templates.structure[i].default_value: null;
        }
      }
    },

    async callLookupAction(method, value, ref) {

      if( method == 'findByIC') {
          this.findByIC(value, ref)
      }else{
        console.log('dev callLookupAction', method, value)
      }
    },

    async findByIC(value, ref) {
      //value = 24254398; //dev
      if(value) {

        let formData = new FormData();
        formData.append('organization_id', value);

        ref.loading = true;
        axios.defaults.baseURL = this.getBaseRoot();
        let apiPath = this.getApiConfig('invoice.find_organization.path')
        axios({
          url: apiPath,
          data: formData,
          method: this.getApiConfig('invoice.find_organization.method'),
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
            if(res.data.status) {
              const data = res.data.response.company_data;

              this.inputs.title = data.title;
              this.inputs.organization_id = data.organization_id;
              this.inputs.tax_id = data.tax_id;
              this.inputs.address = data.address;
              this.inputs.country_code = data.country_code;

              ref.error = null;
            }else{
              ref.error = res.data.err.message;
            }
        })
        .catch((err) => {
          console.error("findAroundByGPS ERR", err);
          ref.error = err;
        })
        .finally(() => {
          ref.loading = false;
        })
      }
    },

    /**************** OLD ************************/


    formatSelectItem ({ id, title, email, login }) {
      return `${title}  ${id} ${email} ${login}`
    },


    getVendorClients() {
      axios.defaults.baseURL = this.getBaseRoot();
      let apiPath = this.getApiConfig('invoice.find_organization_by_vendor.path') + '/' + this.inputObj.params.vendor_id
      //todo
      axios({
        url: apiPath,
        //data: formData,
        method: this.getApiConfig('invoice.find_organization_by_vendor.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log("dev OK getVendorClients RES", res.data.response);
        this.list = res.data.response.list;

      })
      .catch((err) => {

        console.error("getVendorClients ERR", err);
      })
    },

  },

  watch: {
    "inputObj.params.vendor_id": {
      handler(newVal, oldVal) {
        //console.log('watch inputObj.params.vendor_id', this.inputObj.name, newVal, oldVal);
        if(newVal) {
          this.getVendorClients()
        }else{
          this.list = [];
        }

      },
      deep: true,
      immediate: true
    },

    "list": {
      handler(newVal, oldVal) {


        if(
            this.inputObj.params.is_vendor
            && !this.inputModel.id
            && !this.inputModel.title
            && newVal
            && newVal.length == 1
        ) {
          console.log('dev company watch LIST ONE ITEM', this.inputObj.name, newVal.length, newVal[0] );
          //this.inputModel = newVal[0];
        }
      },
      deep: true,
      immediate: true
    },

    "modelValue": {
      handler(newVal, oldVal) {
        if(oldVal != "undefined") {
          if( typeof newVal == 'object'){
            //this.inputModel = newVal;
            for(const index in newVal) {
              //console.log('dev company watch modelValue ITEEM', index, newVal[index]);
              //console.log('dev company watch modelValue XXX', index, newVal[index]);
              this.inputModel[index] = newVal[index]; //zavrzeno
              /**/
              if(this.inputs && typeof this.inputs[index] != "undefined"){
                this.inputs[index] = newVal[index];
              }


            }
            ///console.log('dev company watch modelValue', this.inputObj.name,  this.inputModel );
          }
        }
      },
      deep: true,
      immediate: true
    },

    "inputs": {
      handler(newVal, oldVal) {
        if(newVal) {
          //console.log('dev inputs', newVal );
          this.$emit('update:modelValue', newVal )
        }else{
          this.$emit('update:modelValue', null )
        }
      },
      deep: true,
      immediate: true
    },



    "inputModel": {
      handler(newVal, oldVal) {
        if(newVal) {
          //this.$emit('update:modelValue', newVal )
        }else{
          //this.$emit('update:modelValue', null )
        }
      },
      deep: true,
      immediate: true
    },
  },
};
</script>

<style lang="scss" scoped>

.mapa {
  width: 100%;
  height: 400px;
  border: 1px dashed red;
}

.map-container {
  width: 100%;
  height: 600px;
}

.info-box {
  background: white;
  padding: .7rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 100px;
  max-width: 33vw;

  &[data-zoom][data-zoom="15"] {
    background-color: red;
  }
  &[data-zoom][data-zoom="10"] {
    background-color: navy;
  }

}
/*
.info-box button {
  margin-top: 10px;
  padding: 5px 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.info-box button:hover {
  background: #0056b3;
}
*/
</style>
